import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'smtp-email',
  name: 'Send SMTP Email',
  category: 'integrations',
  description: 'Send emails via SMTP',
  icon: 'Mail',
  color: 'green',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
